export default __webpack_public_path__ + "static/media/CarWash2.de5fc7e0.webp";